import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';
import groq from 'groq';

export const blockReferralSectionFields = groq`
  ...,
  descriptionUnhappy[] {
    ${portableTextWithReferences}
  },
  description[] {
    ${portableTextWithReferences}
  },
`;
